import { IOrderDTO, IProductDTO, ITeamCriteriaDTO } from '@/dtos';
import { get, post } from '../apiWrapper';

export const registerToBranchAPI = async (branchId: string): Promise<ITeamCriteriaDTO> => {
  const year = await post<ITeamCriteriaDTO>(
    `/registration/register-to-branch?branchId=${branchId}`,
  );
  return year;
};

export const getMyRegistrationAPI = async (yearId?: string): Promise<ITeamCriteriaDTO> => {
  let param = '';
  if (yearId) {
    param = `?year=${yearId}`;
  }
  const team = await get<ITeamCriteriaDTO>(`/registration/getMyRegistration${param}`);
  return team;
};

export const addProductToRegistrationAPI = async (
  productVariantId: string,
): Promise<ITeamCriteriaDTO> => {
  const teamCriteria = await post<ITeamCriteriaDTO>(
    `/registration/add-product-to-registration?productVariantId=${productVariantId}`,
  );
  return teamCriteria;
};

export const saveOrderAPI = async (orderDto: IOrderDTO): Promise<IOrderDTO> => {
  const order = await post<IOrderDTO>(`/registration/saveOrder`, orderDto);
  return order;
};

export const finalizeOrderAPI = async (
  orderId: string,
  paymentIntent: string,
): Promise<IOrderDTO> => {
  const order = await post<IOrderDTO>(`/registration/finalizeOrder/${orderId}`, {
    paymentIntent: paymentIntent,
  });
  return order;
};

export const getRegistrationValidationCodeAPI = async (email: string): Promise<boolean> => {
  const code = await get<boolean>(`/registration/getValidationCode?email=${email}`);
  return code;
};

export const validateRegistrationValidationCodeAPI = async (code: string): Promise<boolean> => {
  const validated = await post<boolean>(`/registration/validateValidationCode`, {
    code: code,
  });
  return validated;
};

export const uploadValidationAssetConfirmAPI = async (): Promise<boolean> => {
  const validated = await post<boolean>(`/registration/upload/validation-asset/confirm`);
  return validated;
};

export const getProductByVariantIdAPI = async (variantId: string): Promise<IProductDTO> => {
  const product = await get<IProductDTO>(`/registration/getProductByVariantID?id=${variantId}`);
  return product;
};
